import URL from 'url-parse';
import qs from 'qs';

import config from '../../../config';

const defaultLocale = config('defaultLocale');
const availableLocales = config('availableLocales');

export const SHOP_PAGE_BASE_PATH = '/shop';

export const getUrlWithLocale = (locale, url) => {
  const localePrefix = availableLocales[locale].urlSegment;
  return `${localePrefix}${url}`;
};

export const workLocation = ({
  workId,
  modal = true,
  locale = defaultLocale,
  search = null
} = {}) => {
  if (!workId) return null;

  const localePrefix = availableLocales[locale].urlSegment;
  const location = {
    pathname: `${localePrefix}/explore/works/${workId}`,
    state: { modal }
  };

  if (search) location.search = search;

  return location;
};

export const localiseFullUrl = (url, locale) => {
  const parsedUrl = new URL(url, true);

  parsedUrl.set('pathname', getUrlWithLocale(locale, parsedUrl.pathname));

  return parsedUrl.toString();
};

export const publicAssetPath = filename => `/explore/public/${filename}`;

export const shopTagPath = ({ tag, iaCode, locale, ref }) => {
  if (!tag) return null;

  const slug = tag.split(' ').join('+');

  let path = `${SHOP_PAGE_BASE_PATH}/${slug}`;

  const query = qs.stringify({ iaCode, ref });

  if (iaCode) path += `?${query}`;

  return getUrlWithLocale(locale, path);
};

export const getRedirectUrl = (locale, location) => {
  const redirectLocale = locale === defaultLocale ? '' : `/${locale}`;
  // Matches root location with optional locale prefix (e.g. /, /es, /de, /fr, /es/, /de/, /fr/)
  const isRootLocation = /^\/(es|de|fr)?\/?$/.test(location.pathname);
  return isRootLocation ? `${redirectLocale}/explore/for-you` : null;
};
